import React from "react";

import { useSidebar } from "./hooks/useSidebar";

interface SidebarHeaderProps {
  className?: string;
  children: React.ReactNode;
}

/**
 * SidebarHeader - Sticky header section at the top of the sidebar
 *
 * @param className - Additional CSS classes
 * @param children - Header content
 */
export function SidebarHeader({
  className = "",
  children,
}: SidebarHeaderProps) {
  const { state } = useSidebar();

  return (
    <div
      className={`
        flex flex-col items-center justify-center px-lg py-md
        border-0 border-b border-solid border-primary
        shrink-0 min-h-[52px]
        ${className}
      `.trim()}
      data-state={state}
    >
      {children}
    </div>
  );
}
